import React from 'react';
import { Skeleton } from 'antd';
import { useQuery } from '@apollo/client';
import { AdDetail } from '..';
import { GET_AD_BY_ID } from '../../graphql/queries';
import { AdDetailWrapper } from './style';

const Index = (props) => {
  const { adId, integrationLocalData } = props;

  const { data, loading } = useQuery(GET_AD_BY_ID, {
    variables: { id: adId },
  });
  const adData = data?.list || {};

  if (loading) {
    return (
      <AdDetailWrapper>
        <Skeleton />
      </AdDetailWrapper>
    );
  }

  return <AdDetail data={adData} localData={integrationLocalData} />;
};

export default Index;
